// src/i18n/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export const resources = {
    en: {
        translation: {
            header: {
                appname: "Project MELD",
                tagline: "A Tool for Correct Thinking",
                logout: "Log Out",
                login: "Log In",
                signup: "Sign Up",
                save: "Save My Changes",
                saving: "Saving...",
                savesuccess: "Your changes have been saved successfully!",
                savefailure: "Failed to save. Please try again.",
            },
            models: {
                import: "Import MEL(s)",
                export: "Export MEL(s)",
                create: "Create MEL",
                selectModel: "Select Model",
                noModels: "No models available",
                importsuccess: "Models imported successfully",
                importfailure: "Error importing file. Please ensure it's a valid JSON file."
            },
            tutorial: {
                clickhere: "Click this box to continue...",
                welcome: "Welcome to Project MELD! These MEL diagrams (Model, Evidence, Link) help us reason from evidence to the best choice of models. To begin, select a MEL diagram from the list above.",
                evidence: "Great! Now that you've selected a MEL, click on any of these Evidence rectangles. Notice if you hover over one, it shows you a longer description. When you click it, it should have a dark border and some stuff will show up on the right. An Evidence is a well-known, trusted fact supported by science and observation.",
                model: "Now click on one of these Model circles. Again, you can hover for a longer description. A Model is an explanation, which might or might not be the BEST explanation. We are trying to see which Model is the 'best' one.",
                info: "See these boxes? These are the Model and Evidence you have currently selected. If you click on a different one, it will change. You can only select ONE Model and ONE Evidence at a time. Notice at the bottom of each box you may see one or more reference link buttons [1] [2] etc. You can click these to open background reading for more explanations. CLICK HERE TO CONTINUE.",
                link: "Notice this section in the middle. This is where you decide how the Evidence might relate to the Model. Does the Model provide a good, complete explanation for the Evidence? That's Supports or Strongly Supports. Does the Evidence directly contradict or disprove the Model? In that case, select Contradicts. Click one of these buttons to try it!",
                secondlink: "Great! See how an arrow now connects them? A solid arrow is supports, a thick arrow is strongly supports, and a dashed arrow is contradicts. Try selecting another pair and making another connection!",
                save: "Connect as many of these as makes sense to you. You can remove an existing link by selecting No Effect (the Evidence really doesn't say much about the Model). The Models will grow in size as you connect more Supports/Strongly Supports, and shrink if you connect Contradict. When you are happy with your work, click the Save My Changes above. For now, CLICK HERE TO CONTINUE.",
                references: "Read and think carefully about each Evidence and how it might relate to each Model. You can change your mind at any time. Remember to click the reference links if you need to understand the evidence or model in more detail. CLICK HERE and let's begin!"
            },
            auth: {
                signupLabel: "Sign Up",
                loginLabel: "Login",
                emailLabel: "Email",
                passwordLabel: "Password",
                firstNameLabel: "First Name",
                lastNameLabel: "Last Name",
                displayNameLabel: "Display Name",
                classCodeLabel: "Class Code",
                studentEmail: "Student (Email)",
                studentClass: "Student (Class Code)",
                instructor: "Instructor",
                registerSuccess: "Registration successful!",
                confirmPasswordLabel: "Confirm Password",
                passwordMismatch: "Passwords do not match",
                unableCheck: "Unable to check registration availability.",
                pleaseFill: "Please fill in all required fields",
                loginFailed: "Login failed",
                noAccount: "No account found with these credentials",
                loginSuccess: "Login successful!",
                badPassword: "Invalid password",
                badCode: "Invalid class code. Please check and try again.",
                badValid: "Error validating class code. Please try again.",
                disabled: "New email and instructor registrations are disabled. Please use a class code to register.",
                regFailed: "Registration failed",
                failedCreate: "Failed to create user account",
                failedEmail: "Email is already registered",
                badEmail: "Invalid email format",
                weakPassword: "Password is too weak",
                invalidCode: "Invalid class code",
                errorGeneric: "An error occurred",
                explorer: "Explorer",
                explorerDesc: "Create and test MEL diagrams",
                explorerCodeLabel: "Explorer Code",
                enterExplorerCode: "Please enter your explorer code",
                invalidExplorerCode: "Invalid explorer code",
                studentEmailDesc: "Register with email for permanent account",
                studentClassDesc: "Join using class code",
                instructorDesc: "Create and manage class rosters",
                back: "Back to options"
            },
            info: {
                plausibility: "plausibility",
                translated: "Editing disabled in translated mode",
                title: "Title",
                addnode: "Add New Node",
                nodetitle: "Node Title",
                entertitle: "Enter Node Title",
                evidence: "Evidence",
                model: "Model",
                description: "Description",
                supports: "Supports",
                strongly: "Strongly Supports",
                contradicts: "Contradicts",
                noeffect: "No Effect",
                delete: "Delete",
                cancel: "Cancel",
                titlenodedelete: "Delete Node",
                rusnodedelete: "Are you sure you want to delete this node?",
                titlerefdelete: "Delete Reference",
                rusrefdelete: "Are you sure you want to delete this reference?"
            },
            common: {
                loading: "Loading...",
                error: "Error",
                success: "Success",
                cancel: "Cancel",
                save: "Save",
                back: "Back",
                delete: "Delete",
                edit: "Edit",
                close: "Close",
                confirm: "Confirm",
                yes: "Yes",
                no: "No"
            }
        }
    },
    es: {
        translation: {
            header: {
                appname: "Proyecto MELD",
                tagline: "Una Herramienta para el Pensamiento Correcto",
                logout: "Cerrar Sesión",
                login: "Iniciar Sesión",
                signup: "Registrarse",
                save: "Guardar Cambios",
                saving: "Guardando...",
                savesuccess: "¡Tus cambios se han guardado correctamente!",
                savefailure: "Error al guardar. Por favor, inténtalo de nuevo.",
            },
            models: {
                import: "Importar MEL(s)",
                export: "Exportar MEL(s)",
                create: "Crear MEL",
                selectModel: "Seleccionar Modelo",
                noModels: "No hay modelos disponibles",
                importsuccess: "Modelos importados correctamente",
                importfailure: "Error al importar el archivo. Asegúrate de que sea un archivo JSON válido."
            },
            tutorial: {
                clickhere: "Haz clic aquí para continuar...",
                welcome: "¡Bienvenido a Proyecto MELD! Estos diagramas MEL (Modelo, Evidencia, Vínculo) nos ayudan a razonar desde la evidencia hasta la mejor elección de modelos. Para comenzar, selecciona un diagrama MEL de la lista anterior.",
                evidence: "¡Excelente! Ahora que has seleccionado un MEL, haz clic en cualquiera de estos rectángulos de Evidencia. Observa que si pasas el cursor sobre uno, muestra una descripción más larga. Cuando hagas clic, tendrá un borde oscuro y aparecerá información a la derecha. Una Evidencia es un hecho conocido y confiable respaldado por la ciencia y la observación.",
                model: "Ahora haz clic en uno de estos círculos de Modelo. Nuevamente, puedes pasar el cursor para ver una descripción más larga. Un Modelo es una explicación, que puede o no ser la MEJOR explicación. Estamos tratando de ver qué Modelo es el 'mejor'.",
                info: "¿Ves estas cajas? Son el Modelo y la Evidencia que has seleccionado actualmente. Si haces clic en uno diferente, cambiará. Solo puedes seleccionar UN Modelo y UNA Evidencia a la vez. Observa que al final de cada caja puedes ver uno o más botones de enlaces de referencia [1] [2] etc. Puedes hacer clic en estos para abrir lecturas de fondo para más explicaciones. HAZ CLIC AQUÍ PARA CONTINUAR.",
                link: "Observa esta sección en el medio. Aquí es donde decides cómo la Evidencia podría relacionarse con el Modelo. ¿El Modelo proporciona una explicación buena y completa para la Evidencia? Eso es Apoya o Apoya Fuertemente. ¿La Evidencia contradice o refuta directamente el Modelo? En ese caso, selecciona Contradice. ¡Haz clic en uno de estos botones para probarlo!",
                secondlink: "¡Excelente! ¿Ves cómo una flecha los conecta ahora? Una flecha sólida significa apoya, una flecha gruesa significa apoya fuertemente, y una flecha punteada significa contradice. ¡Intenta seleccionar otro par y hacer otra conexión!",
                save: "Conecta tantos como tenga sentido para ti. Puedes eliminar un enlace existente seleccionando Sin Efecto (la Evidencia realmente no dice mucho sobre el Modelo). Los Modelos crecerán en tamaño a medida que conectes más Apoya/Apoya Fuertemente, y se reducirán si conectas Contradice. Cuando estés satisfecho con tu trabajo, haz clic en Guardar Mis Cambios arriba. Por ahora, HAZ CLIC AQUÍ PARA CONTINUAR.",
                references: "Lee y piensa cuidadosamente sobre cada Evidencia y cómo podría relacionarse con cada Modelo. Puedes cambiar de opinión en cualquier momento. Recuerda hacer clic en los enlaces de referencia si necesitas entender la evidencia o el modelo con más detalle. HAZ CLIC AQUÍ y comencemos!"
            },
            auth: {
                signupLabel: "Registrarse",
                loginLabel: "Iniciar Sesión",
                emailLabel: "Correo Electrónico",
                passwordLabel: "Contraseña",
                firstNameLabel: "Nombre",
                lastNameLabel: "Apellido",
                displayNameLabel: "Nombre para Mostrar",
                classCodeLabel: "Código de Clase",
                studentEmail: "Estudiante (Correo)",
                studentClass: "Estudiante (Código de Clase)",
                instructor: "Instructor",
                registerSuccess: "¡Registro exitoso!",
                confirmPasswordLabel: "Confirmar Contraseña",
                passwordMismatch: "Las contraseñas no coinciden",
                unableCheck: "No se puede verificar la disponibilidad del registro.",
                pleaseFill: "Por favor complete todos los campos requeridos",
                loginFailed: "Error de inicio de sesión",
                noAccount: "No se encontró cuenta con estas credenciales",
                loginSuccess: "¡Inicio de sesión exitoso!",
                badPassword: "Contraseña inválida",
                badCode: "Código de clase inválido. Por favor, verifica e intenta de nuevo.",
                badValid: "Error al validar el código de clase. Por favor, intenta de nuevo.",
                disabled: "Las nuevas inscripciones por correo electrónico y de instructores están desactivadas. Por favor, utilice un código de clase para registrarse.",
                regFailed: "Registro fallido",
                failedCreate: "Error al crear la cuenta de usuario",
                failedEmail: "El correo electrónico ya está registrado",
                badEmail: "Formato de correo electrónico inválido",
                weakPassword: "La contraseña es demasiado débil",
                invalidCode: "Código de clase inválido",
                errorGeneric: "Ocurrió un error",
                explorer: "Explorador",
                explorerDesc: "Crear y probar diagramas MEL",
                explorerCodeLabel: "Código de Explorador",
                enterExplorerCode: "Por favor ingrese su código de explorador",
                invalidExplorerCode: "Código de explorador inválido",
                studentEmailDesc: "Registrarse con correo para cuenta permanente",
                studentClassDesc: "Unirse usando código de clase",
                instructorDesc: "Crear y gestionar listas de clase",
                back: "Volver a opciones"
            },
            info: {
                plausibility: "plausibilidad",
                translated: "Edición desactivada en modo traducido",
                title: "Título",
                addnode: "Añadir Nuevo Nodo",
                nodetitle: "Título del Nodo",
                entertitle: "Introducir Título del Nodo",
                evidence: "Evidencia",
                model: "Modelo",
                description: "Descripción",
                supports: "Apoya",
                strongly: "Apoya Fuertemente",
                contradicts: "Contradice",
                noeffect: "Sin Efecto",
                delete: "Eliminar",
                cancel: "Cancelar",
                titlenodedelete: "Eliminar nodo",
                rusnodedelete: "¿Está seguro de que desea eliminar este nodo?",
                titlerefdelete: "Eliminar referencia",
                rusrefdelete: "¿Está seguro de que desea eliminar esta referencia?"
            },
            common: {
                loading: "Cargando...",
                error: "Error",
                success: "Éxito",
                cancel: "Cancelar",
                save: "Guardar",
                delete: "Eliminar",
                edit: "Editar",
                close: "Cerrar",
                confirm: "Confirmar",
                yes: "Sí",
                no: "No"
            }
        }
    },
    uk: {
        translation: {
            header: {
                appname: "Проект MELD",
                tagline: "Інструмент для Правильного Мислення",
                logout: "Вийти",
                login: "Увійти",
                signup: "Зареєструватися",
                save: "Зберегти Зміни",
                saving: "Збереження...",
                savesuccess: "Ваші зміни успішно збережено!",
                savefailure: "Помилка збереження. Будь ласка, спробуйте ще раз.",
            },
            models: {
                import: "Імпортувати MEL(и)",
                export: "Експортувати MEL(и)",
                create: "Створити MEL",
                selectModel: "Вибрати Модель",
                noModels: "Немає доступних моделей",
                importsuccess: "Моделі успішно імпортовано",
                importfailure: "Помилка імпорту файлу. Переконайтеся, що це дійсний файл JSON."
            },
            tutorial: {
                clickhere: "Натисніть тут, щоб продовжити...",
                welcome: "Ласкаво просимо до Проекту MELD! Ці діаграми MEL (Модель, Докази, Зв'язок) допомагають нам міркувати від доказів до найкращого вибору моделей. Щоб почати, виберіть діаграму MEL зі списку вище.",
                evidence: "Чудово! Тепер, коли ви вибрали MEL, натисніть на будь-який з цих прямокутників Доказів. Зауважте, що якщо ви наведете на нього курсор, з'явиться довший опис. Коли ви натиснете на нього, з'явиться темна рамка і деяка інформація праворуч. Доказ - це відомий, перевірений факт, підтверджений наукою та спостереженнями.",
                model: "Тепер натисніть на одне з цих кіл Моделі. Знову ж таки, ви можете навести курсор для довшого опису. Модель - це пояснення, яке може бути або не бути НАЙКРАЩИМ поясненням. Ми намагаємось визначити, яка Модель є 'найкращою'.",
                info: "Бачите ці вікна? Це Модель і Докази, які ви зараз вибрали. Якщо ви натиснете на інший, він зміниться. Ви можете вибрати лише ОДНУ Модель та ОДИН Доказ одночасно. Зверніть увагу, що внизу кожного вікна ви можете побачити одну або більше кнопок посилань [1] [2] тощо. Ви можете натиснути на них, щоб відкрити додаткову інформацію для більш детального пояснення. НАТИСНІТЬ ТУТ, ЩОБ ПРОДОВЖИТИ.",
                link: "Зверніть увагу на цю секцію посередині. Тут ви вирішуєте, як Докази можуть стосуватися Моделі. Чи надає Модель хороше, повне пояснення Доказів? Це Підтримує або Сильно Підтримує. Чи Докази прямо суперечать або спростовують Модель? У такому випадку виберіть Суперечить. Натисніть одну з цих кнопок, щоб спробувати!",
                secondlink: "Чудово! Бачите, як стрілка тепер з'єднує їх? Суцільна стрілка означає підтримку, товста стрілка означає сильну підтримку, а пунктирна стрілка означає суперечність. Спробуйте вибрати іншу пару та створити ще одне з'єднання!",
                save: "З'єднайте стільки, скільки має сенс для вас. Ви можете видалити існуючий зв'язок, вибравши Без Ефекту (Докази насправді мало говорять про Модель). Моделі будуть збільшуватися в розмірі, коли ви додаєте більше Підтримує/Сильно Підтримує, і зменшуватися, якщо ви додаєте Суперечить. Коли ви задоволені своєю роботою, натисніть Зберегти Мої Зміни вгорі. Поки що НАТИСНІТЬ ТУТ, ЩОБ ПРОДОВЖИТИ.",
                references: "Уважно прочитайте та подумайте про кожний Доказ і про те, як він може стосуватися кожної Моделі. Ви можете змінити свою думку в будь-який час. Пам'ятайте, що можна натискати на посилання, якщо вам потрібно краще зрозуміти докази або модель. НАТИСНІТЬ ТУТ і почнемо!"
            },
            auth: {
                signupLabel: "Зареєструватися",
                loginLabel: "Увійти",
                emailLabel: "Електронна пошта",
                passwordLabel: "Пароль",
                firstNameLabel: "Ім'я",
                lastNameLabel: "Прізвище",
                displayNameLabel: "Відображуване ім'я",
                classCodeLabel: "Код класу",
                studentEmail: "Студент (Email)",
                studentClass: "Студент (Код класу)",
                instructor: "Викладач",
                registerSuccess: "Реєстрація успішна!",
                confirmPasswordLabel: "Підтвердити Пароль",
                passwordMismatch: "Паролі не співпадають",
                unableCheck: "Неможливо перевірити доступність реєстрації.",
                pleaseFill: "Будь ласка, заповніть усі обов'язкові поля",
                loginFailed: "Помилка входу",
                noAccount: "Не знайдено облікового запису з такими даними",
                loginSuccess: "Вхід успішний!",
                badPassword: "Невірний пароль",
                badCode: "Невірний код класу. Будь ласка, перевірте і спробуйте ще раз.",
                badValid: "Помилка перевірки коду класу. Будь ласка, спробуйте ще раз.",
                disabled: "Нові реєстрації електронною поштою та реєстрації інструкторів вимкнено. Будь ласка, використовуйте код класу для реєстрації.",
                regFailed: "Помилка реєстрації",
                failedCreate: "Не вдалося створити обліковий запис користувача",
                failedEmail: "Ця електронна пошта вже зареєстрована",
                badEmail: "Невірний формат електронної пошти",
                weakPassword: "Пароль занадто слабкий",
                invalidCode: "Недійсний код класу",
                errorGeneric: "Сталася помилка",
                explorer: "Дослідник",
                explorerDesc: "Створюйте та тестуйте діаграми MEL",
                explorerCodeLabel: "Код дослідника",
                enterExplorerCode: "Будь ласка, введіть код дослідника",
                invalidExplorerCode: "Недійсний код дослідника",
                studentEmailDesc: "Зареєструватися з електронною поштою для постійного облікового запису",
                studentClassDesc: "Приєднатися за допомогою коду класу",
                instructorDesc: "Створювати та керувати списками класів",
                back: "Назад до опцій"
            },
            info: {
                plausibility: "правдоподібність",
                translated: "Редагування вимкнено в перекладеному режимі",
                title: "Назва",
                addnode: "Додати Новий Вузол",
                nodetitle: "Назва Вузла",
                entertitle: "Введіть Назву Вузла",
                evidence: "Доказ",
                model: "Модель",
                description: "Опис",
                supports: "Підтримує",
                strongly: "Сильно Підтримує",
                contradicts: "Суперечить",
                noeffect: "Без Впливу",
                delete: "Видалити",
                cancel: "Скасувати",
                titlenodedelete: "Видалити вузол",
                rusnodedelete: "Ви впевнені, що хочете видалити цей вузол?",
                titlerefdelete: "Видалити посилання",
                rusrefdelete: "Ви впевнені, що хочете видалити це посилання?"
            },
            common: {
                loading: "Завантаження...",
                error: "Помилка",
                success: "Успішно",
                cancel: "Скасувати",
                save: "Зберегти",
                delete: "Видалити",
                edit: "Редагувати",
                close: "Закрити",
                confirm: "Підтвердити",
                yes: "Так",
                no: "Ні"
            }
        }
    },
    fr: {
        translation: {
            header: {
                appname: "Projet MELD",
                tagline: "Un Outil pour la Pensée Correcte",
                logout: "Déconnexion",
                login: "Connexion",
                signup: "S'inscrire",
                save: "Enregistrer mes modifications",
                saving: "Enregistrement...",
                savesuccess: "Vos modifications ont été enregistrées avec succès !",
                savefailure: "Échec de l'enregistrement. Veuillez réessayer.",
            },
            models: {
                import: "Importer MEL(s)",
                export: "Exporter MEL(s)",
                create: "Créer MEL",
                selectModel: "Sélectionner un modèle",
                noModels: "Aucun modèle disponible",
                importsuccess: "Modèles importés avec succès",
                importfailure: "Erreur lors de l'importation du fichier. Assurez-vous qu'il s'agit d'un fichier JSON valide."
            },
            tutorial: {
                clickhere: "Cliquez sur cette boîte pour continuer...",
                welcome: "Bienvenue dans le Projet MELD ! Ces diagrammes MEL (Modèle, Evidence, Lien) nous aident à raisonner des preuves vers le meilleur choix de modèles. Pour commencer, sélectionnez un diagramme MEL dans la liste ci-dessus.",
                evidence: "Parfait ! Maintenant que vous avez sélectionné un MEL, cliquez sur l'un de ces rectangles de Preuve. Remarquez que si vous survolez l'un d'eux, il affiche une description plus longue. Lorsque vous cliquez dessus, il doit avoir une bordure foncée et des informations apparaîtront à droite. Une Preuve est un fait connu et fiable soutenu par la science et l'observation.",
                model: "Maintenant, cliquez sur l'un de ces cercles de Modèle. Là encore, vous pouvez survoler pour une description plus longue. Un Modèle est une explication, qui peut être ou non la MEILLEURE explication. Nous essayons de voir quel Modèle est le 'meilleur'.",
                info: "Voyez-vous ces boîtes ? Ce sont le Modèle et la Preuve que vous avez actuellement sélectionnés. Si vous cliquez sur un autre, il changera. Vous ne pouvez sélectionner qu'UN SEUL Modèle et UNE SEULE Preuve à la fois. Notez qu'au bas de chaque boîte, vous pouvez voir un ou plusieurs boutons de référence [1] [2] etc. Vous pouvez cliquer dessus pour ouvrir des lectures de fond pour plus d'explications. CLIQUEZ ICI POUR CONTINUER.",
                link: "Remarquez cette section au milieu. C'est ici que vous décidez comment la Preuve pourrait être liée au Modèle. Le Modèle fournit-il une bonne explication complète de la Preuve ? C'est Soutient ou Soutient Fortement. La Preuve contredit-elle ou réfute-t-elle directement le Modèle ? Dans ce cas, sélectionnez Contredit. Cliquez sur l'un de ces boutons pour essayer !",
                secondlink: "Excellent ! Voyez-vous comment une flèche les relie maintenant ? Une flèche pleine signifie soutient, une flèche épaisse signifie soutient fortement, et une flèche en pointillés signifie contredit. Essayez de sélectionner une autre paire et de créer une autre connexion !",
                save: "Connectez autant d'éléments que cela vous semble logique. Vous pouvez supprimer un lien existant en sélectionnant Sans Effet (la Preuve ne dit pas grand-chose sur le Modèle). Les Modèles grandiront à mesure que vous connectez plus de Soutient/Soutient Fortement, et rétréciront si vous connectez Contredit. Lorsque vous êtes satisfait de votre travail, cliquez sur Enregistrer mes modifications ci-dessus. Pour l'instant, CLIQUEZ ICI POUR CONTINUER.",
                references: "Lisez et réfléchissez attentivement à chaque Preuve et à la façon dont elle pourrait être liée à chaque Modèle. Vous pouvez changer d'avis à tout moment. N'oubliez pas de cliquer sur les liens de référence si vous avez besoin de mieux comprendre la preuve ou le modèle. CLIQUEZ ICI et commençons !"
            },
            auth: {
                signupLabel: "S'inscrire",
                loginLabel: "Connexion",
                emailLabel: "Email",
                passwordLabel: "Mot de passe",
                firstNameLabel: "Prénom",
                lastNameLabel: "Nom",
                displayNameLabel: "Nom d'affichage",
                classCodeLabel: "Code de classe",
                studentEmail: "Étudiant (Email)",
                studentClass: "Étudiant (Code de classe)",
                instructor: "Instructeur",
                registerSuccess: "Inscription réussie !",
                confirmPasswordLabel: "Confirmer le Mot de Passe",
                passwordMismatch: "Les mots de passe ne correspondent pas",
                unableCheck: "Impossible de vérifier la disponibilité de l'inscription.",
                pleaseFill: "Veuillez remplir tous les champs requis",
                loginFailed: "Échec de la connexion",
                noAccount: "Aucun compte trouvé avec ces identifiants",
                loginSuccess: "Connexion réussie !",
                badPassword: "Mot de passe invalide",
                badCode: "Code de classe invalide. Veuillez vérifier et réessayer.",
                badValid: "Erreur lors de la validation du code de classe. Veuillez réessayer.",
                disabled: "Les nouvelles inscriptions par e-mail et d'instructeurs sont désactivées. Veuillez utiliser un code de classe pour vous inscrire.",
                regFailed: "Échec de l'inscription",
                failedCreate: "Échec de la création du compte utilisateur",
                failedEmail: "L'email est déjà enregistré",
                badEmail: "Format d'email invalide",
                weakPassword: "Le mot de passe est trop faible",
                invalidCode: "Code de classe invalide",
                errorGeneric: "Une erreur s'est produite",
                explorer: "Explorateur",
                explorerDesc: "Créer et tester des diagrammes MEL",
                explorerCodeLabel: "Code d'explorateur",
                enterExplorerCode: "Veuillez entrer votre code d'explorateur",
                invalidExplorerCode: "Code d'explorateur invalide",
                studentEmailDesc: "S'inscrire avec email pour un compte permanent",
                studentClassDesc: "Rejoindre avec un code de classe",
                instructorDesc: "Créer et gérer les listes de classe",
                back: "Retour aux options"
            },
            info: {
                plausibility: "plausibilité",
                translated: "Édition désactivée en mode traduit",
                title: "Titre",
                addnode: "Ajouter un Nouveau Nœud",
                nodetitle: "Titre du Nœud",
                entertitle: "Entrer le Titre du Nœud",
                evidence: "Preuve",
                model: "Modèle",
                description: "Description",
                supports: "Soutient",
                strongly: "Soutient Fortement",
                contradicts: "Contredit",
                noeffect: "Sans Effet",
                delete: "Supprimer",
                cancel: "Annuler",
                titlenodedelete: "Supprimer le nœud",
                rusnodedelete: "Êtes-vous sûr de vouloir supprimer ce nœud ?",
                titlerefdelete: "Supprimer la référence",
                rusrefdelete: "Êtes-vous sûr de vouloir supprimer cette référence ?"
            },
            common: {
                loading: "Chargement...",
                error: "Erreur",
                success: "Succès",
                cancel: "Annuler",
                save: "Enregistrer",
                delete: "Supprimer",
                edit: "Modifier",
                close: "Fermer",
                confirm: "Confirmer",
                yes: "Oui",
                no: "Non"
            }
        }
    },
    zh: {
        translation: {
            header: {
                appname: "MELD项目",
                tagline: "正确思维的工具",
                logout: "退出登录",
                login: "登录",
                signup: "注册",
                save: "保存更改",
                saving: "保存中...",
                savesuccess: "您的更改已成功保存！",
                savefailure: "保存失败。请重试。",
            },
            models: {
                import: "导入MEL",
                export: "导出MEL",
                create: "创建MEL",
                selectModel: "选择模型",
                noModels: "没有可用的模型",
                importsuccess: "模型导入成功",
                importfailure: "导入文件错误。请确保它是有效的JSON文件。"
            },
            tutorial: {
                clickhere: "点击此框继续...",
                welcome: "欢迎使用MELD项目！这些MEL图（模型、证据、链接）帮助我们从证据推理到最佳模型选择。首先，从上方列表中选择一个MEL图。",
                evidence: "很好！现在您已选择了MEL，请点击这些证据矩形之一。注意，如果您将鼠标悬停在其上，它会显示更长的描述。当您点击它时，它会有一个深色边框，右侧会显示一些内容。证据是由科学和观察支持的已知可信事实。",
                model: "现在点击这些模型圆圈之一。同样，您可以悬停以查看更长的描述。模型是一种解释，可能是也可能不是最佳解释。我们试图看出哪个模型是'最佳'的。",
                info: "看到这些框了吗？这些是您当前选择的模型和证据。如果您点击其他的，它会改变。您一次只能选择一个模型和一个证据。注意在每个框的底部，您可能会看到一个或多个参考链接按钮[1] [2]等。您可以点击这些按钮打开背景阅读以获取更多解释。点击此处继续。",
                link: "注意中间的这个部分。这是您决定证据如何可能与模型相关的地方。模型是否为证据提供了很好的完整解释？那就是支持或强烈支持。证据是否直接矛盾或反驳模型？在这种情况下，选择矛盾。点击这些按钮之一试试！",
                secondlink: "太好了！看到箭头是如何连接它们的了吗？实线箭头表示支持，粗箭头表示强烈支持，虚线箭头表示矛盾。试着选择另一对并建立另一个连接！",
                save: "连接您认为有意义的所有内容。您可以通过选择无效果来删除现有链接（证据对模型实际上没有太多说明）。随着您连接更多的支持/强烈支持，模型会变大，如果您连接矛盾，则会变小。当您对您的工作满意时，点击上方的保存我的更改。现在，点击此处继续。",
                references: "仔细阅读和思考每个证据以及它们如何可能与每个模型相关。您可以随时改变主意。如果您需要更详细地了解证据或模型，请记得点击参考链接。点击此处让我们开始！"
            },
            auth: {
                signupLabel: "注册",
                loginLabel: "登录",
                emailLabel: "电子邮件",
                passwordLabel: "密码",
                firstNameLabel: "名",
                lastNameLabel: "姓",
                displayNameLabel: "显示名称",
                classCodeLabel: "班级代码",
                studentEmail: "学生（电子邮件）",
                studentClass: "学生（班级代码）",
                instructor: "教师",
                registerSuccess: "注册成功！",
                confirmPasswordLabel: "确认密码",
                passwordMismatch: "密码不匹配",
                unableCheck: "无法检查注册可用性。",
                pleaseFill: "请填写所有必填字段",
                loginFailed: "登录失败",
                noAccount: "未找到使用这些凭据的账户",
                loginSuccess: "登录成功！",
                badPassword: "密码无效",
                badCode: "班级代码无效。请检查并重试。",
                badValid: "验证班级代码时出错。请重试。",
                disabled: "新的电子邮件和教师注册已禁用。请使用班级代码进行注册。",
                regFailed: "注册失败",
                failedCreate: "创建用户账户失败",
                failedEmail: "电子邮件已被注册",
                badEmail: "电子邮件格式无效",
                weakPassword: "密码太弱",
                invalidCode: "班级代码无效",
                errorGeneric: "发生错误",
                explorer: "探索者",
                explorerDesc: "创建和测试MEL图",
                explorerCodeLabel: "探索者代码",
                enterExplorerCode: "请输入您的探索者代码",
                invalidExplorerCode: "探索者代码无效",
                studentEmailDesc: "使用电子邮件注册永久账户",
                studentClassDesc: "使用班级代码加入",
                instructorDesc: "创建和管理班级名单",
                back: "返回选项"
            },
            info: {
                plausibility: "可信度",
                translated: "翻译模式下禁用编辑",
                title: "标题",
                addnode: "添加新节点",
                nodetitle: "节点标题",
                entertitle: "输入节点标题",
                evidence: "证据",
                model: "模型",
                description: "描述",
                supports: "支持",
                strongly: "强烈支持",
                contradicts: "矛盾",
                noeffect: "无影响",
                delete: "删除",
                cancel: "取消",
                titlenodedelete: "删除节点",
                rusnodedelete: "您确定要删除此节点吗？",
                titlerefdelete: "删除引用",
                rusrefdelete: "您确定要删除此引用吗？"
            },
            common: {
                loading: "加载中...",
                error: "错误",
                success: "成功",
                cancel: "取消",
                save: "保存",
                delete: "删除",
                edit: "编辑",
                close: "关闭",
                confirm: "确认",
                yes: "是",
                no: "否"
            }
        }
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }
    });

export default i18n;